import { faPause, faPlay } from "@fortawesome/pro-regular-svg-icons";
import { Box } from "@mui/material";

import { Icon } from "@/components/ui-v2/Icon/Icon";
import { IconButton } from "@/components/ui-v2/IconButton/IconButton";

interface AudioToolbarProps {
  isPlaying: boolean;
  onClick: () => void;
}

export const AudioToolbar = (props: AudioToolbarProps) => {
  const { isPlaying, onClick } = props;

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pt: 8,
      }}
    >
      <IconButton
        rounded
        onClick={onClick}
        aria-label="Play"
        size="large"
        sx={{
          fontSize: 32,
          width: 60,
          height: 60,
          maxWidth: "none",
          maxHeight: "none",
        }}
      >
        <Icon icon={isPlaying ? faPause : faPlay} />
      </IconButton>
    </Box>
  );
};
